import React, { Component, createContext } from 'react';
import PropTypes from 'prop-types';

export const defaultAccordionContextValues = {
  activeKey: '0',
  toggleEvents: {},
  setToggleEvent: () => {},
  setActiveKey: () => {},
};

export const AccordionContext = createContext(
  defaultAccordionContextValues,
);

export class AccordionContextProvider extends Component {
  constructor(props) {
    super(props);

    this.setToggleEvent = (eventKey) => {
      this.setState((prevState) => ({
        toggleEvents: {
          ...prevState.toggleEvents,
          [prevState.activeKey]: Date.now(),
          [eventKey]: Date.now(),
        },
      }));
    };

    this.setActiveKey = (activeKey) => {
      this.setToggleEvent(activeKey);
      this.setState({ activeKey });
      props.onChange(activeKey);
    };

    this.state = {
      activeKey:
        props.activeKey || defaultAccordionContextValues.activeKey,
      toggleEvents: defaultAccordionContextValues.toggleEvents,
      setToggleEvent: this.setToggleEvent,
      setActiveKey: this.setActiveKey,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.activeKey &&
      this.props.activeKey !== prevProps.activeKey &&
      this.props.activeKey !== this.state.activeKey
    )
      this.setActiveKey(this.props.activeKey);
  }

  render() {
    const { children } = this.props;
    return (
      <AccordionContext.Provider value={this.state}>
        {children}
      </AccordionContext.Provider>
    );
  }
}

AccordionContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  activeKey: PropTypes.string,
  onChange: PropTypes.func,
};

AccordionContextProvider.defaultProps = {
  activeKey: null,
  onChange: () => {},
};
